import script from "./DesktopPreviewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopPreviewer.vue?vue&type=script&setup=true&lang=js"

import "./DesktopPreviewer.vue?vue&type=style&index=0&id=4dfdc219&lang=scss"

const __exports__ = script;

export default __exports__